import { mdlBaseHotelIdRequest } from "../models/service-models/common/BaseHotelIdRequest";
import { mdlServiceResponse } from "../models/service-models/common/ServiceResponse";
import { mdlHotelPaymentResponse } from "../models/service-models/payment/HotelPaymentResponse";
import { mdlPayableHotelListRequest } from "../models/service-models/payment/PayableHotelListRequest";
import { mdlPayableHotelListResponse } from "../models/service-models/payment/PayableHotelListResponse";
import { GetResponse } from "../utils/ApiClient";

namespace PaymentService {
    export async function GetHotelPaymentData(
        pRequest: mdlBaseHotelIdRequest
    ): Promise<mdlServiceResponse<mdlHotelPaymentResponse>> {
        return await GetResponse<mdlServiceResponse<mdlHotelPaymentResponse>>(
            "payment/getHotelPaymentData",
            pRequest
        );
    }
    
    export async function GetPayableHotelList(
        pRequest: mdlPayableHotelListRequest
    ): Promise<mdlServiceResponse<mdlPayableHotelListResponse>> {
        return await GetResponse<mdlServiceResponse<mdlPayableHotelListResponse>>(
            "payment/getPayableHotelList",
            pRequest
        );
    }
}

export { PaymentService };